const ManageReports = 'ManageReports';

export const CREATE_REPORT_REQUEST = `${ManageReports}/CREATE_REPORT_REQUEST`;
export const REPORT_CREATED = `${ManageReports}/REPORT_CREATED`;
export const CREATE_REPORT_ERROR = `${ManageReports}/CREATE_REPORT_ERROR`;

export const FETCH_FILTERED_REPORTS_REQUEST = `${ManageReports}/FETCH_FILTERED_REPORTS_REQUEST`;
export const FETCH_FILTERED_REPORTS_ERROR = `${ManageReports}/FETCH_FILTERED_REPORTS_ERROR`;
export const RECEIVED_FILTERED_REPORTS = `${ManageReports}/RECEIVED_FILTERED_REPORTS`;
export const GENERATE_REPORTS_LIST = `${ManageReports}/GENERATE_REPORTS_LIST`;

export const SELECT_SINGLE_REPORT = `${ManageReports}/SELECT_SINGLE_REPORT`;
export const DESELECT_SINGLE_REPORT = `${ManageReports}/DESELECT_SINGLE_REPORT`;
export const SELECT_ALL_REPORTS = `${ManageReports}/SELECT_ALL_REPORTS`;
export const DESELECT_ALL_REPORTS = `${ManageReports}/DESELECT_ALL_REPORTS`;
